import { useMediaQuery } from 'react-responsive';

function useIsMobile(mobileMaxWidth = 576) {
  const isMobile = useMediaQuery({ maxWidth: mobileMaxWidth });
  return isMobile;
}

export default useIsMobile;
